<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import formatters from '@/mixins/formatters.js';

export default {
   name: 'EmailControlTab',
   components: { DatePicker },
   mixins: { formatters },
   data() {
      return {
         step: 'form', // 'form' | 'confirm'
         form: {
            targetPayoutDate: '',
            scheduleEmailDate: '',
            scheduleEmailTime: '09:00',
         },
         previewRows: {
            data: [],
            current_page: 1,
            per_page: 10,
            total: 10
         },
         // previewRows: [],
         payoutHeaderIds: [],
         loading: false,
         showSuccessModal: false,
      };
   },
   computed: {
      emailDateTime() {
         return `${this.form.scheduleEmailDate} ${this.form.scheduleEmailTime}`;
      }
   },
   methods: {
      async showFacilityListWithPayout(query) {
         // Validate
         if (!this.form.targetPayoutDate || !this.form.scheduleEmailDate || !this.form.scheduleEmailTime) {
            this.$bvToast && this.$bvToast.toast('Please complete all fields.', { title: 'Error', variant: 'danger', autoHideDelay: 2000 });
            return;
         }

         this.loading = true;

         try {
            const payload = {
               date_from: this.form.targetPayoutDate,
               date_to: this.form.targetPayoutDate,
               status: 'confirmed',
               mode: 'payout-email-schedule',
               page: query && query.page ? query.page : 1,
               per_page: query && query.per_page ? query.per_page : 10,
            }
            // API call to get facilities with payout on selected date
            const res = await this.$lionheart.post('/v2/payout-list/search', { ...payload });
            const resultData = res.data.data || [];
            this.previewRows = {
               data: resultData.data || [],
               current_page: resultData.current_page || query.page || 1,
               per_page: resultData.per_page || query.per_page || 10,
               total: resultData.total || (resultData.data ? resultData.data.length : 0),
            };
            // get all the payout ids in the result data
            // this.payoutHeaderIds = this.previewRows.map(row => row.id);
            this.step = 'confirm';
            this.loading = false
         } catch (e) {
            console.error('Failed to load facilities:', e);
            this.$bvToast && this.$bvToast.toast('Failed to load facilities.', { variant: 'danger', autoHideDelay: 2000 });
         } finally {
            this.loading = false;
         }
      },
      async onSubmit() {
         try {
            const payload = {
               schedule_date: this.form.scheduleEmailDate,
               schedule_time: this.form.scheduleEmailTime,
               payout_header_ids: this.payoutHeaderIds,
               target_payout_date: this.form.targetPayoutDate,
            }
            // API call can be re-enabled when backend is ready
            const res = await this.$lionheart.post('/v2/payout-email-schedules/confirm-create', { ...payload });
            if(res.status !== 201) {
               this.$bvToast && this.$bvToast.toast('Failed to schedule the email.', { variant: 'danger', autoHideDelay: 2000 });
               return;
            }
            // Show success modal styled like the screenshot
            this.showSuccessModal = true;
         } catch (e) {
            console.error('Failed to schedule the email:', e);
            this.$bvToast && this.$bvToast.toast('Failed to schedule the email.', { variant: 'danger', autoHideDelay: 2000 });
         } finally {
            this.loading = false;
         }
      },
      onBack() {
         this.form.targetPayoutDate = '';
         this.form.scheduleEmailDate = '';
         this.form.scheduleEmailTime = '09:00';
         this.previewRows = [];
         this.payoutHeaderIds = [];
         this.step = 'form';
      },
      onModalBack() {
         this.showSuccessModal = false;
         this.onBack();
         this.$router.push({ name: 'checkin-admin-payout-list-arbitrage' });
      },
      async paginate(page) {
         var filter = {
            page: page,
            per_page: this.previewRows.per_page
         };
         await this.showFacilityListWithPayout(filter);
      },
   }
};
</script>

<template>
  <div class="p-3">
    <div class="card">
      <div class="card-body">
        <template v-if="step === 'form'">
          <p class="text-muted mb-4">Set up the emails to be sent after entering the payout list and transaction list.</p>
          <b-form @submit.prevent="showFacilityListWithPayout">
            <b-form-group label="Target Payout date">
               <date-picker v-model="form.targetPayoutDate" valueType="YYYY-MM-DD" :default-value="new Date()" format="YYYY/MM/DD" placeholder="YYYY/MM/DD" />
            </b-form-group>
            <b-form-group label="Schedule Email Date">
               <date-picker v-model="form.scheduleEmailDate" valueType="YYYY-MM-DD" :default-value="new Date()" format="YYYY/MM/DD" placeholder="YYYY/MM/DD" />
            </b-form-group>
            <b-form-group label="Schedule Email Time">
               <date-picker
                 v-model="form.scheduleEmailTime"
                 valueType="HH:mm"
                 type="time"
                 format="HH:mm"
                 placeholder="09:00"
                 :time-picker-options="{ start: '07:00', step: '01:00', end: '20:00' }"
               />
            </b-form-group>
            <div class="text-center">
              <b-button type="submit" variant="primary" :disabled="loading">{{ loading ? 'Loading...' : 'Next' }}</b-button>
            </div>
          </b-form>
        </template>

        <template v-else>
          <p class="text-muted mb-4">Confirm that list of pre-scheduled email for payout before sending.</p>
          <div class="table-responsive table-bordered">
            <table class="table table-bordered mb-3">
              <thead>
                <tr>
                  <th>Facility</th>
                  <th>Payout Date</th>
                  <th>Email Date/Time</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, idx) in previewRows.data" :key="idx">
                  <td>{{ row.facility?.name }}</td>
                  <td>{{ row.payout_date }}</td>
                  <td>{{ formatDateTimeToSlash(emailDateTime, true) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="text-center">
            <b-button class="mr-2" variant="outline-secondary" @click="onBack">Back</b-button>
            <b-button variant="primary" @click="onSubmit" v-if="this.previewRows.data.length > 0">Submit</b-button>
          </div>
          <div class="col-sm-8">
            <pagination
               v-model="previewRows.current_page"
               :per-page="previewRows.per_page"
               :records="previewRows.total"
               @paginate="paginate"
            ></pagination>
         </div>
        </template>

        <!-- Success Modal -->
        <b-modal v-model="showSuccessModal" centered hide-header hide-footer size="md">
          <div class="text-center py-4">
            <div class="h1 mb-4 text-muted">Email Scheduled</div>
            <b-button variant="primary" @click="onModalBack" style="min-width: 140px;">Back</b-button>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
